<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429919197_toc01#toctitle1" id="title1"><span><strong class="b">acknowledgments</strong></span></a></div>
<div class="p"><span>Thanks to Leslie Daniels, the best agent (and friend) a nervous (neurotic?) and superstitious (psycho?) writer could have. Thanks also to Elizabeth Beier, my fabulous editor and the only person I know who can actually use “fabulous” in a spoken sentence without sounding weird—<em class="i">Oops, we did it again, ooh baby bay-buh!</em> Hugs and thanks to Matthew Shear, cheery master of the paperback universe; Matthew Baldacci, sickeningly fit master of the marketing universe; and John Murphy, cynical king of the hell that is the public relations universe. Thanks to artmaster Michael Storrings for the sexy, savvy covers that put books in hands. Finally, <em class="i">un montón de</em> thanks to Sally Richardson, brilliant and benevolent queen of the entire wacky (in a <em class="i">good</em> way, honest!) universe according to Saint Martin. Thanks too to the Albuquerque Fire Department girls, for letting me hang around the station. You ladies rock!</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429919197_ack01.vue?6ad45287